import React from 'react';
import './FooterCTA.css';
import { Link } from 'react-router-dom';

import brochurePDF from '../../assets/brochures/crishi-brochure.pdf';

const FooterCTA = () => {
  return (
    <section className="footer-cta-section">
      <div className="footer-cta-container">
        <h2>Let's discuss your business needs</h2>
        <p className="cta-subtitle">
          Stay ahead with CRISHI: unlock smart insight, transparent pricing, and global data for better decisions every day.
        </p>
        <div className="cta-buttons">
          {/* 3. Wrap "Book a demo" button in a Link to the signup page */}
          <Link to="/signup">
            <button className="book-demo-btn-red">Book a demo</button>
          </Link>
           <a href={brochurePDF} target="_blank" rel="noopener noreferrer">
            <button className="download-brochure-btn">Download brochure</button>
          </a>
        </div>
        <p className="contact-info">
          crishi@agalabs.com | +91-9319882279
        </p>
      </div>
    </section>
  );
};

export default FooterCTA;